define('rest/copyright',["http", "security", "./utils"],
    function (http, security, utils) {
        "use strict";

        return {
            /**
             * Gets copyright information for given NDS maps areas.
             * In addition to basic copyright for the whole map, API is serving specific groups of copyrights for some
             * countries which are written in JSON, JSONP or XML format.
             * @example
             *  var options = {
             *      minLon: -106.8224,
             *      minLat: 34.9246,
             *      maxLon: -106.4008,
             *      maxLat: 35.3234
             * };
             *  copyrights.copyrights(options, function(response) { ... });
             *
             * @method copyrights
             * @param {Object} options Options to be passed to the copyrights call.
             * @param {Object} options.minLon Minimum longitude coordinate of bounding box.
             * @param {Object} options.minLat Minimum latitude coordinate of bounding box.
             * @param {Object} options.maxLon Maximum longitude coordinate of bounding box.
             * @param {Object} options.maxLat Maximum latitude coordinate of bounding box.
             * @param {Object} options.key API Key valid for requested service.
             * @param {Function} [options.fail] The callback function to be called on failure.
             * @param {Function} callback The callback function to be called on success.
             */
            copyrights: function (options, callback) {
                var pathParams = {},
                    queryParams = {},
                    baseUrl = utils.or(options.baseUrl, "{protocol}://api.tomtom.com/"),
                    serviceUrl;

                // if an API key is specified, include it
                // an API key can be omitted if an API proxy is being used
                queryParams.key = utils.or(options.key, security.getKey("services/display"));

                serviceUrl = utils.or(options.serviceUrl, "map/1/copyrights.{contentType}");
                // if minLon, minLat, maxLon, maxLot params are not provided user wants to obtain the default copyright
                // information for the whole world
                if (options.minLon && options.minLat && options.maxLon && options.maxLat) {
                    pathParams.minLon = options.minLon;
                    pathParams.minLat = options.minLat;
                    pathParams.maxLon = options.maxLon;
                    pathParams.maxLat = options.maxLat;
                    serviceUrl = serviceUrl.replace("copyrights.{contentType}", "copyrights/{minLon}/{minLat}/{maxLon}/{maxLat}.{contentType}");
                }

                http.get({
                    url: baseUrl + serviceUrl,
                    pathParameters: pathParams,
                    queryParameters: queryParams,
                    callback: callback,
                    callbackParam: "callback",
                    fail: options.fail
                });
            },

            /**
             * Gets copyright caption to be displayed on map.
             * The user may request the copyrights caption. It is a short message with basic copyrights information. It
             * may be used to provide a text for a html link which points to more detailed information.
             * @example
             *  copyrights.caption(options, function(response) { ... });
             *
             * @method caption
             * @param {Object} options Options to be passed to the copyrights call.
             * @param {String} options.key API Key valid for requested service.
             * @param {Function} [options.fail] The callback function to be called on failure.
             * @param {Function} callback The callback function to be called on success.
             */
            caption: function (options, callback) {
                var pathParams = {},
                    queryParams = {},
                    baseUrl = utils.or(options.baseUrl, "{protocol}://api.tomtom.com/"),
                    serviceUrl;

                // if an API key is specified, include it
                // an API key can be omitted if an API proxy is being used
                queryParams.key = utils.or(options.key, security.getKey("services/display"));

                serviceUrl = utils.or(options.serviceUrl, "map/1/copyrights/caption.{contentType}");

                http.get({
                    url: baseUrl + serviceUrl,
                    pathParameters: pathParams,
                    queryParameters: queryParams,
                    callback: callback,
                    callbackParam: "callback",
                    fail: options.fail
                });
            }
        };
    }
);

